var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 16.1998V12.2998H16.2V16.1998H13.2L18 21.3998L22.8 16.1998H19.8ZM12 22.6998H24V23.9998H12V22.6998Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "#F2F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowload);
export default __webpack_public_path__ + "static/media/dowload.3d3bc8dba17d675a9b81f56343424b20.svg";
export { ForwardRef as ReactComponent };